import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import React from 'react';
import { useDefaultComponentValue } from '../../utils';
import { useHandleClose } from '../AppbarUserContext';
const COMPONENT_NAME = 'CloseableUserItem';
const CloseableUserItem = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { onClick, ...rest } = props;
    const handleClose = useHandleClose();
    return /*#__PURE__*/ React.createElement(MenuItem, {
        ...rest,
        onClick: ()=>{
            onClick?.();
            handleClose();
        }
    });
};
CloseableUserItem.propTypes = {
    onClick: PropTypes.func
};
export default CloseableUserItem;
